import { render } from "./BatchesPage.vue?vue&type=template&id=d816ca6a"
import script from "./BatchesPage.vue?vue&type=script&lang=js"
export * from "./BatchesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__